import React from 'react';
import {
	Create,
	Datagrid,
	Edit,
	EditButton,
	List,
	SimpleForm,
	TextInput,
	TextField,
} from 'react-admin';

import {
	WithMasterPermissions,
} from '../DataProviderExtension/authExtension';

export const editCategory = (props) => {
	return (
		<Edit {...props}>
			<SimpleForm>
				<TextInput label="Название" source="title" />
			</SimpleForm>
		</Edit>
	);
};

export const createCategory = (props) => {
	return (
		<Create {...props}>
			<SimpleForm>
				<TextInput label="Название" source="title" />
			</SimpleForm>
		</Create>
	);
};

export const listCategory = (props) => {
	return (
		<List {...props} title="Категории">
			<Datagrid rowClick="edit">
				<TextField label="Название" source="title" />
				<WithMasterPermissions>
					<EditButton />
				</WithMasterPermissions>
			</Datagrid>
		</List>
	);
};
